export default "__VITE_ASSET__4ca6c9df__"